import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const useHorizontalButtonSetStyles = makeStyles(
  (theme) => ({
    title: {
      color: TextColors.light,
      marginBottom: theme.spacing(1),
    },
    setButtonWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: theme.spacing(0, -1.5, 0),
    },
    buttonWrapper: {
      padding: theme.spacing(0, 1.5),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        marginBottom: 0,
      },
    },
  }),
  { name: 'HorizontalButtonSet' },
);

export default useHorizontalButtonSetStyles;
